<template>
  <div class="field" :style="field.style" v-if="condition">
    <label class="label">{{ field.label }}</label>
    <div class="control">
      <div v-if="loading" class="is-size-7 has-text-grey"><i class="fa-solid fa-spinner fa-spin mr-1"></i> Duke ngarkuar...</div>
      <div v-else-if="!categoryGuid" class="is-size-7 has-text-grey">Zgjidhni kategorinë e produktit.</div>
      <div v-else class="web-cats-readonly">
        <div v-if="path.length >= 3" class="is-size-7 mb-1"><strong>Kategoria web 1:</strong> {{ webCat1 || '—' }}</div>
        <div v-if="path.length >= 2" class="is-size-7 mb-1"><strong>Kategoria web 2:</strong> {{ webCat2 || '—' }}</div>
        <div v-if="path.length >= 1" class="is-size-7 mb-1"><strong>Kategoria web 3:</strong> {{ webCat3 || '—' }}</div>
        <div v-if="path.length === 0" class="is-size-7 has-text-grey">Kategoria ka më pak se tre nivele.</div>
      </div>
    </div>
  </div>
</template>

<script>
import CategoriesServices from "@/services/Category";

function findFieldValue(fields, name, type) {
  if (!fields || !Array.isArray(fields)) return null;
  for (const row of fields) {
    const arr = Array.isArray(row) ? row : [row];
    for (const f of arr) {
      if (f && f.name === name) {
        if (type === "tree-select" && f.selected_options && typeof f.selected_options === "object") {
          const keys = Object.keys(f.selected_options);
          return keys.length === 1 ? keys[0] : keys.length > 1 ? keys[0] : null;
        }
        if (type === "checkbox" || type === "number") return f.value;
        return f.value;
      }
    }
  }
  return null;
}

export default {
  props: ["field", "fields"],
  data() {
    return {
      loading: false,
      path: [],
    };
  },
  computed: {
    condition() {
      const inWeb = findFieldValue(this.fields, "in_web");
      return inWeb === 1 || inWeb === "1";
    },
    isAccessory() {
      const v = findFieldValue(this.fields, "is_accessory");
      return v === 1 || v === "1";
    },
    categoryGuid() {
      const name = this.isAccessory ? "accessory_id" : "type_id";
      const guid = findFieldValue(this.fields, name, "tree-select");
      return guid && guid !== "EMPTY-STRING" ? guid : null;
    },
    webCat1() {
      const len = this.path.length;
      return len >= 3 ? this.path[len - 3].name : null;
    },
    webCat2() {
      const len = this.path.length;
      return len >= 2 ? this.path[len - 2].name : null;
    },
    webCat3() {
      const len = this.path.length;
      return len >= 1 ? this.path[len - 1].name : null;
    },
  },
  watch: {
    categoryGuid: {
      immediate: true,
      handler(guid) {
        this.path = [];
        if (!guid) return;
        this.loading = true;
        CategoriesServices.getCategoryPath(guid, true, this.isAccessory ? "accessories" : "products")
          .then((data) => {
            this.path = Array.isArray(data) ? data : [];
          })
          .catch(() => {
            this.path = [];
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  },
};
</script>
